import i18n from 'i18next';
import { STREAMING_ASPECT_RATIOS } from 'utils/helpers/moba-games-statistics-options';
import { isMobile } from 'utils/is-mobile';
import { GameInfoAdditionalDataMap } from 'interfaces/sportsbook-data-levels';

export const DOTA_2_SETTINGS = {
  titles: {
    0: null,
    get 1() {
      return i18n.t('sportsbook.esportsKill');
    },
    get 2() {
      return i18n.t('sportsbook.tormentor');
    },
    get 3() {
      return i18n.t('sportsbook.tower');
    },
    get 4() {
      return i18n.t('sportsbook.barrack');
    },
    get 5() {
      return i18n.t('sportsbook.barrack');
    }
  },
  icons: {
    names: {
      1: 'kill',
      2: 'dragon',
      3: 'tower',
      4: 'inhibitor',
      5: null
    },
    firstSanctuary: {
      0: 'voidgrub-kill'
    },
    secondSanctuary: {},
    positions: {
      roshen: isMobile()
        ? { top: '32%', left: '37.8%' }
        : { top: '33%', left: '34.9%' },
      tower: isMobile()
        ? {
            1: { top: '75.1%', left: '28%' },
            2: { top: '77%', left: '29.5%' },
            3: { top: '66.2%', left: '25.5%' },
            4: { top: '70.2%', left: '32.2%' },
            5: { top: '82.4%', left: '34.7%' },
            6: { top: '50.5%', left: '26.7%' },
            7: { top: '61.2%', left: '36.2%' },
            8: { top: '83.4%', left: '47.5%' },
            9: { top: '34.1%', left: '26.3%' },
            10: { top: '54.2%', left: '42.5%' },
            11: { top: '82.2%', left: '64.9%' },
            12: { top: '9.2%', left: '32.1%' },
            13: { top: '41.2%', left: '49.7%' },
            14: { top: '56.2%', left: '69.5%' },
            15: { top: '9.2%', left: '48%' },
            16: { top: '32.2%', left: '56.8%' },
            17: { top: '43.2%', left: '69.4%' },
            18: { top: '10.2%', left: '60.1%' },
            19: { top: '22.4%', left: '63%' },
            20: { top: '26.9%', left: '69.5%' },
            21: { top: '15.9%', left: '65%' },
            22: { top: '17.9%', left: '66.3%' }
          }
        : {
            1: { top: '75.1%', left: '21.9%' },
            2: { top: '77%', left: '23.1%' },
            3: { top: '66.2%', left: '18.5%' },
            4: { top: '70.2%', left: '26.5%' },
            5: { top: '82.4%', left: '29.7%' },
            6: { top: '50.5%', left: '19.7%' },
            7: { top: '61.2%', left: '32.2%' },
            8: { top: '83.4%', left: '47.5%' },
            9: { top: '34.1%', left: '19.3%' },
            10: { top: '54.2%', left: '40.5%' },
            11: { top: '82.2%', left: '69.7%' },
            12: { top: '9.2%', left: '26.1%' },
            13: { top: '41.2%', left: '49.7%' },
            14: { top: '56.2%', left: '75.7%' },
            15: { top: '9.2%', left: '48%' },
            16: { top: '32.2%', left: '59%' },
            17: { top: '43.2%', left: '75.4%' },
            18: { top: '10.2%', left: '63.1%' },
            19: { top: '23.4%', left: '67%' },
            20: { top: '26.9%', left: '76%' },
            21: { top: '15.9%', left: '70%' },
            22: { top: '17.9%', left: '71.5%' }
          },
      kills: isMobile()
        ? {
            1: { top: '69.1%', left: '24.7%' },
            2: { top: '68.7%', left: '26.3%' },
            3: { top: '71.1%', left: '30.9%' },
            4: { top: '74.1%', left: '31.9%' },
            5: { top: '81.1%', left: '33.2%' },
            6: { top: '85.1%', left: '33.3%' },
            7: { top: '8%', left: '61.4%' },
            8: { top: '12%', left: '61.4%' },
            9: { top: '20%', left: '62.9%' },
            10: { top: '23%', left: '63.9%' },
            11: { top: '25%', left: '68.5%' },
            12: { top: '25%', left: '70.5%' }
          }
        : {
            1: { top: '69.1%', left: '16.7%' },
            2: { top: '69.7%', left: '19%' },
            3: { top: '72.1%', left: '24.9%' },
            4: { top: '74.1%', left: '25.9%' },
            5: { top: '81.1%', left: '27.9%' },
            6: { top: '85.1%', left: '27.9%' },
            7: { top: '8%', left: '64.9%' },
            8: { top: '12%', left: '65.4%' },
            9: { top: '20%', left: '66.9%' },
            10: { top: '23%', left: '68.9%' },
            11: { top: '25%', left: '74.9%' },
            12: { top: '25%', left: '76.9%' }
          }
    },
    getIconPositionsAndSizes: function (width: number) {
      const size = {
        width: width / STREAMING_ASPECT_RATIOS.desktop,
        height: width / STREAMING_ASPECT_RATIOS.desktop
      };

      return {
        0: {
          position: this.positions.roshen,
          size
        },
        1: {
          position: this.positions.kills,
          size
        },
        2: {
          size: isMobile()
            ? {
                width: width / STREAMING_ASPECT_RATIOS.mobile,
                height: width / STREAMING_ASPECT_RATIOS.mobile
              }
            : size,
          position: this.positions || {}
        }
      };
    }
  }
};

export const getDota2Statistics = (
  additionalDataMap: GameInfoAdditionalDataMap | undefined
) => {
  const roshen =
    (additionalDataMap?.timers || []).find(
      roshen => roshen.codeValue === 'roshan_timer'
    )?.value ?? -1;

  return {
    statistics: {
      1: {
        ...(isMobile() ? { 5: null } : { 0: null }),
        1: additionalDataMap?.killScore?.team1 || 0,
        2: additionalDataMap?.tormentorScore?.team1 || 0,
        3: additionalDataMap?.towerScore?.team1 || 0,
        4: additionalDataMap?.barrackScore?.team1 || 0
      },
      2: {
        1: additionalDataMap?.killScore?.team2 || 0,
        2: additionalDataMap?.tormentorScore?.team2 || 0,
        3: additionalDataMap?.towerScore?.team2 || 0,
        4: additionalDataMap?.barrackScore?.team2 || 0,
        5: null
      }
    },
    mapState: {
      1:
        additionalDataMap?.destroyedBarracks.map(barrack => barrack.number) ||
        [],
      2: additionalDataMap?.destroyedTowers.map(tower => tower.number) || [],
      3: roshen,
      4: -1
    }
  };
};
